import type { ApiError } from "../../api/client";
import { IMPORT_MAX_POSITIONS } from "../../lib/structureImport";

type Translate = (key: string, fallback: string, opts?: Record<string, unknown>) => string;

/** Server errors of the import and its drafts (sprint 5j) as Serbian sentences — code → text, never the raw message. */
export function importErrorText(t: Translate, err: ApiError): string {
  const details = err.details as unknown as Record<string, unknown> | undefined;
  switch (err.code) {
    case "IMPORT_FILE_UNREADABLE": return t("structureImport.error.unreadable", "Fajl nije čitljiv Excel (.xlsx) ni CSV (.csv).");
    case "IMPORT_FILE_TOO_LARGE": return t("structureImport.error.fileTooLarge", "Fajl je veći od 5 MB.");
    case "IMPORT_FORMAT": return t("structureImport.error.format", "Ovo nije izvoz strukture iz CAD-a kakav očekujemo: nema kolona „IME MODELA NA H.D.“ i „KOLICINA“.");
    case "IMPORT_EMPTY": return t("structureImport.error.empty", "U fajlu nema stavki strukture.");
    case "IMPORT_CYCLE": return t("structureImport.error.cycle", "Struktura sadrži samu sebe (sklop „{{model}}“), pa od nje ne može da se napravi drvo.", { model: String(details?.model ?? "") });
    case "IMPORT_TOO_LARGE": return t("structureImport.error.tooLarge", "Previše pozicija za jedan uvoz (najviše {{limit}}). Skini deo stavki.", { limit: IMPORT_MAX_POSITIONS });
    case "DRAFT_STALE": return t("structureImport.error.stale", "Neko je u međuvremenu menjao ovaj nacrt. Učitaj ga ponovo da vidiš izmene.");
    case "DRAFT_IMPORTED": return t("structureImport.error.imported", "Ovaj nacrt je već uvezen u strukturu.");
    case "NOT_FOUND": return t("structureImport.error.notFound", "Nacrt ne postoji ili je obrisan.");
    case "VALIDATION":
      if (details?.targetParentId) return t("structureImport.error.target", "Izabrana pozicija više ne postoji — izaberi drugu.");
      return t("structureImport.error.validation", "Uvoz nije prošao proveru. Proveri nazive i vrste označenih stavki.");
    case "FORBIDDEN":
    case "OUT_OF_SCOPE": return err.message;
    default: return t("structureImport.error.generic", "Nešto nije uspelo. Pokušaj ponovo.");
  }
}
